export default __webpack_public_path__ + "static/media/ooc-deception-roc.d7c6fc71.webp";